import { ComponentType, lazy } from "react";

/**
 * Maps stepId strings to lazy-loaded Page components.
 *
 * Only steps that require custom page-level logic (unique layout, complex
 * interactive UI, or terminal booking actions) are registered here.
 *
 * All other steps use GenericStepPage, which wraps PageLayout +
 * DynamicStepRenderer for schema-driven rendering and contract-based submit.
 *
 * Previously held: get-started, calendar-windows, truck-loads.
 * These components are now self-contained and rendered via component
 * content blocks through DynamicStepRenderer.
 */

const ConfirmationPage = lazy(() =>
  import("../../../pages").then((m) => ({ default: m.ConfirmationPage })),
);

const GetStartedPage = lazy(() =>
  import("../../../pages").then((m) => ({ default: m.GetStartedPage })),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pageRegistry: Record<string, ComponentType<any>> = {
  "get-started": GetStartedPage,
  confirmation: ConfirmationPage,
};
